import Vue from 'vue'
import store from '..'
import firebase from 'firebase/app'
import 'firebase/firestore'

export default {
  namespaced: true,
  state () {
    return {
      shares: [],
      reference: null
    }
  },
  getters: {
    shares (state) {
      return state.shares
    },
    reference (state) {
      return state.reference
    }
  },
  mutations: {
    init (state, payload) {
      state.shares = payload
    },
    add (state, payload) {
      state.shares.push(payload)
    },
    update (state, payload) {
      const index = state.shares.findIndex(share => share.key === payload.key)
      if (index !== -1) {
        Vue.set(state.shares, index, payload)
      }
    },
    remove (state, payload) {
      const index = state.shares.findIndex(share => share.key === payload.key)
      if (index !== -1) {
        state.shares.splice(index, 1)
      }
    },
    reference (state, payload) {
      state.reference = payload
    }
  },
  actions: {
    init ({ commit }) {
      return new Promise((resolve) => {
        commit('init', [])
        resolve()
      })
    },
    subscribe ({ commit }) {
      var boot = true
      var temp = []
      return new Promise((resolve) => {
        commit('init', [])
        const db = firebase.firestore()
        var dbRef = db.collection('shares_statics')
        var reference = dbRef.onSnapshot(snapshots => {
          if (snapshots.empty) {
            resolve()
          }
          snapshots.docChanges().forEach(change => {
            var data = JSON.parse(JSON.stringify(change.doc.data()))
            data.key = change.doc.id
            if (boot && change.type === 'added') {
              temp.push(data)
            } else if (change.type === 'added') {
              commit('add', data)
            } else if (change.type === 'modified') {
              commit('update', data)
            } else if (change.type === 'removed') {
              commit('remove', data)
            }
          })
          if (boot) {
            boot = false
            commit('init', temp)
          }
          resolve()
        })
        commit('reference', reference)
      })
    },
    unSubscribe ({ commit }) {
      var reference = store.getters['sharesStatics/reference']
      return new Promise((resolve) => {
        if (reference) {
          reference()
          commit('reference', null)
          commit('init', [])
          resolve()
        } else {
          resolve()
        }
      })
    },
    update ({ commit }, payload) {
      return new Promise((resolve) => {
        const db = firebase.firestore()
        var dbRef = db.collection('shares_statics').doc(payload.key)
        return db.runTransaction((transaction) => {
          return transaction.get(dbRef).then((sfDoc) => {
            var whoRead = {}
            var view = 1
            if (!sfDoc.exists) {
              whoRead[payload.uid] = payload.status
              transaction.set(dbRef, { view: view, whoRead: whoRead })
            } else {
              whoRead = sfDoc.data().whoRead
              if (payload.status) {
                view = sfDoc.data().view + 1
              } else {
                view = sfDoc.data().view
              }
              whoRead[payload.uid] = payload.status
              transaction.update(dbRef, { view: view, whoRead: whoRead })
            }
          })
        }).then(() => {
          resolve()
        }).catch((error) => {
          if (error) {
          }
          resolve()
        })
      })
    }
  }
}
